import { computed, type Ref } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { GET_STUDENT_DATA_REQUESTS } from '@/graphql/studentDataRequests';
import type { StudentDataRequestStatus } from '@/types/composition-functions';
import type { StudentDataRequestsQuery, StudentDataRequestsQueryVariables } from '@/types/operations';

/** The school's data requests, newest first, optionally only open or closed ones (needs Students → View). */
export function useStudentDataRequests(status: Ref<StudentDataRequestStatus | null>) {
  const { result, loading, error, refetch } = useQuery<StudentDataRequestsQuery, StudentDataRequestsQueryVariables>(
    GET_STUDENT_DATA_REQUESTS,
    () => ({ status: status.value }),
    { fetchPolicy: 'cache-and-network' },
  );

  return {
    requests: computed(() => result.value?.studentDataRequests ?? []),
    loading,
    error,
    refetch,
  };
}
